<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        v-if="['ACCOUNT'].includes(this.values)"
        prop="reportDate"
        width="120"
        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"
        width="100"
        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        sortable
        prop="CTR"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="80"
        prop="spent"
        label="花费">
      </el-table-column>
      <el-table-column
        sortable
        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>

      <el-table-column
        sortable
        prop="webPay"
        label="网页购买">
      </el-table-column>
      <el-table-column
        prop="customPayCount"
        label="自定义付费数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdyff"
        label="自定义付费数成本">
      </el-table-column>
      <el-table-column
        prop="reactivation"
        label="自定义拉活数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdylh"
        label="自定义拉活数成本">
      </el-table-column>
      <el-table-column
        prop="customRetainCount"
        label="自定义次留">
      </el-table-column>
      <el-table-column
        prop="zdycl"
        label="自定义次留成本">
      </el-table-column>
<!--      <el-table-column-->
<!--        sortable-->
<!--        prop="CVR"-->
<!--        :formatter="ChangeToPercentage"-->
<!--        label="转化率">-->
<!--      </el-table-column>-->
<!--      sortable-->
<!--      <el-table-column-->
<!--        prop="CLR"-->
<!--        :formatter="ChangeToPercentage"-->
<!--        label="次留率">-->
<!--      </el-table-column>-->
      <el-table-column
        prop="addWechatMpaCount"
        label="微信-添加微信数">
      </el-table-column>
      <el-table-column
        prop="dialogueMpaCount"
        label="首次消息数">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from "../until/excel";
export default {


  data() {
    return {
      activeName: 'first',

      dialog1:false,
      xiane:true,
      isDisable:false,
      userUalue:'',
      options1: [
        {
          value: 'wangxin',
          label: '王行',
          children: [{
            value: 'cesuan',
            label: '测算',
          },
          ]
        },
        {
          value: 'jiaqi1',
          label: '佳琪',
          children: [{
            value: 'hzbxm1',
            label: '快手',
          },
          ]
        },
        {
          value: 'xiaoqing',
          label: '小晴',
          children: [{

              value: 'zjwc1',
              label: '浙江挖财'
            }]
        },
        {
          value: 'tangtang',
          label: '唐唐  ',
          children: [{
            value: 'fjwc',
            label: '福建挖财'
          }]
        }],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],

      //数据
      cesuan:[
        '5b20bd74eb15c545c7bc',
        '64e76166f270d122f4d7',
        '027cbdbd0666b6f33620',
        'ef8784c5b98cdf1f8e83',
        '68283ffe9bcdd2de589b',
        'e3f6fd682f94cfacd4bd',
        'ab05672bac950e22eead',
        'e81796eb039b6b8d7791',
        '6278d7a304ac02f69792',
        '65d2478ab38f8185879c',
        '8da496c2e2ac5f61c972',
        '965462a040269dcf2866',
        '70b19b26cf19b291ac14',
        '3c8db992ac883b1f873c',
        'c7abe3622801607f37ba',
        '8c6f7e8a516e53a0affd',

        '967e90a9d7d51e8858be',
        '33fb00f3bb693213aa48'
      ],
      wangxin:['370ead1291f5735f6181a107270609f3fc40569c2a8fa733c487f10c18acb4fc'],
      jiaqi1:['da7cae1e3c1248621ea327e59f95593b83813d1f75c03ceb3c86d6f3e0f9a05e','b0cef9537a17a19b2951383ea3a6e9d7a339ca27e66952067adefc23d2ccb701'],
      hzbxm1:[
        '693600fe65b63e047b70',
        'a254a593704e5d8bb202',
        'fe4f16305d912bfbe0c9',
        '6a3bd0430c3c1e91ffbb',
        '8a3d42b3d9883feade96',
        'cbd0edf8553fc3afa351',
        'db694e6ef6f1f84bab55',
        '2aa93df32ce9fe012579',
        '3af0f3d27ddabb899981',
        '76c6d8e12d9a30ff87a8',
        '5f2bcc2acf06044cd538',
        'a5115789b5b7313d48b0',
        '6fb3de147558e0847b8c',
        'bb1dca832a0a7bec1750',
        '7fdc80ae190187651cc0',
        '28ee78b2f3d6a34772ce',
        '79495bddebfca604c06c',
        'd2c8c31d114748499f27',
        'f0fdcc5771856189fb9f',
        '646ffe3a8321200865cd',
        'fe112748d34013dab4c8',
        'dc4b6ce08fae55c13dfb',
        'a0ffa2e802ec6f628a03',
        '949e71fdb609ca76a921',
        'a2754c2146893389dc9d',
        '38687dbd95549f8aa7ea',
        '198502f1dbd6b78ad3eb',
        'd385b80bf5f30ce20851',
        '4ce253bc30798e1726ce',
        'acce6191cceb1eed3519',
        '2a97882ea81c859f7f2d',
        '45eb5597c560d215a651',
        'a03c9429dd3c81dc2b4a',
        '6617e12a1a2a044e6a7c',
        'ac93f9a4437249319d17',
        '3e815bfde6e8ba38ba35',
        '9f70aa2ca47bf57b9a4a',
        '92f1bb71f40d5bd12008',
        '1b2f57e16bb556b6d8b3',
        'd8480b92c3079234a86e',

      ],
      hzbxm2:['eb30ebd17af764f6b9d3',
        'da4af964c8f94e4cf87f',
        '3122389e9cf22d94cc2d',
        'a3cdeafc7658146ff4f5',
        'e04c1c06105efd94a130',
        '6c6acc4a59b7ccaa7066',
        '7b9daacd2b7bb5dc67d1',
        'e2052e758f373f9caf59',
        '413ed9011834e6ef8885',
        'f55313cfe206871140aa',
      ],
      xiaoqing:['1b39ec617071e23de1c865ea772c1eace6392f195781a9128405a0d19920ea3d','e02e2618fc793dc152d82ce2ded524f97d775e108b295a1ce338117ca096fd5f',
        'cb40eea503b274dadca8c71634393d407af24c9c0c2aa095c7c8665ec07f1d4e','b76f84d0eb68aea6faee58e82ad7cc652f7187eb23ef1b9d3d7f8eeb09cfba10','155c2a24cccce986528990fa6401d22ae727a8d49dc98dd64d2b752993a59923'
      ], fjwctoken:['9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8'],
      xiaoqing1:['4fa940040985146f070b1eb8f19cc3084570842faca8bf7317e470e0d5d97149','bebae681e51f6c6d61181a1068bd861766755848946f1839d649ca4933378a86','e18203affbefa3ae8a544f4932ba0c816acdee42026cebaccad62af898f1480b'],
      zjwc1:[
        '2a635788e3415c6fba8a','66a7b19ca7a72e1132ca','d03aa6d90e971e0bb521','32b2963dd5f1039d07b4','f7a036a8d223d75afe81','d14a1d574918dfd19c32','01a49abdaf82d1a34208','e390777c36f5377b5b2a','e704f96a853cae59bb05','e298058e570a3eb95787','54332bff2fa8c2abe93f','d83d46b0417be5769395','22517a03145e9ebb3fe0',
        '419e8721af4154b65bd1',
        'c5058e2a9206c1dad94f',
        '95e2dc791586257714ea',
        '419e8721af4154b65bd1',
        '91136e4b7b02f1fa690e',

        '311594e23fa579a1558c','289c0a58eec14fe09f42','1f4c3c5a952f6f3b269e','b5c575a3802fe4f91b6f','8de17a9ec42a0006ec56',
        '98c77b001e2c36b8a857',
        '3ee140adcd4ef4ccbc10',
        'b510d1bf06f83682c908',
        'ebe5b575ba7fb9374460',
        '3e284992e8eb3ddee01e',
        '4e08a68b32ca3c1dd318',
        '129c376324e52470ba69',
        '63af19b3afff60c16cec',
        '5900d0307afa139046db',
        '0bc07cf476dc77ee783e',

        '62da67881828038e62da',
        '57a325b34c2a38456941',
        'c78aec395f35bc89d6be',
        '1e23cd300d959ea95826',
        '19ab188e2d75672d6469',
        'adde77095fa40916f74b',
        '725227701e8a5dccb99d',
        '55b4e55da65d1b9f928d',
        '8d3dfe7cfc341b746fa3',

        'fbb25b0c7285a282082e',
        '7980baabd85f0fbabee9',
        '8e554700b4c89410b45a',
        '985d67bdda8aae51f300',
        '4e9c8d847fd4d2c4cdfb',


        '6efeb7c0b4e29b03b3a2',
        'b56cd3fbc80a9314765f',
        'aca0e160b3a586a9ba68',
        'b8172866349a30513e8c',
        '3b33188c6cf82b1042da',
        '7c3fdddd82065a98bfb1',

        '35f1977c9adf243cfdfc',
        '5ec07ce78b12767525eb',
        'a2c77fde9e408fd69d74',
        '986abf3523f5505d79d9',
        'def5b36f3d51e20c619c',
        '766d54d8d22021a3aac3',
      ],
      jsgx:['208538fad40c9796ec00','08de207541e54d033eb7','66046cfed9f87891115e','f0760f6cfe8d319e3bef','a1254894a9a764c6816b','8625b7a0955d398442a4','d1d4707e543526a059e2','480ea6b22f8ffa50e136','0e2399938ab77f5b91cc'],
      jstb:['f3d4eb9d4acfeccbd1bf','6888ae8ac48159ec2fa3','dce582c5ba18e4763eb6','9855ab445099a15b00e7','78e3e38db1293782c583'],
      ysgx:['9a3be560564b951550a6','c77c4948b07e8322c93f','e45ffb7db04197a72fe1','de4a95c9472a36aa9e38','586f137a4a132e09c285'],
      zuoen:['c2a16d4047d3d096b2700701fb5caba784e3c1031903fc8207b97b56909ab7a7'],
      marryu:['873a63615f6e42478a3b','1c96ea51e138b5a10655','01739c18a49cff216f35','d9dadce1a1edf45a862d','a99e101d860a977cb6dd','baa7f15045eed2cf32d5'],
      tangtang:['1f36ae8dfbc9403b6ca06e80e3d4d9c6ae0268e990f3019e5bb91df14ea287ea','9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8','a823e200bc8f6a8edbbb56335c65ef65aa9bfa6e67f902ef073a28c97608ee71'],
      zjwc: ['d58d2e06d91f1fcc1734'],
      fjwc:['0df944cca119c270225a',
        '3399e2d64883f8380d63','efcdca45ba190a8fac43',
        '523232813295c58319d9','c4a990831562f25a58be',
        '9db7b3816397c12af284','a66e2afd3fd50539e5ec'
        ,'9071fd2d5b9b757b9b2d','2626b6fcdf4d91dff0fc',
        '091fe378ca7aa0bb5c94','103e87eb2d92bc66047b','4003ecf9ea17d42a9c03','fe40c7a6030b5b3e9c95','2cc7a556dd567c45a608',
        '716b52a489c8da4a56d9','c01ec4bc93b0c7dd4c54','8827f3e71c29b5dfe6e5','c65f194a303422fe2d11','032d4a2d87dac1ccb9e5','619c1a576a7f3304caa5','059eef7825360cb4a212'
        ,'54993d3787a9ef0fe149'
      ,'b0ced990246896269f35'
        ,'48ade4a1456272e488d8'
        ,'994ec93d6be3ed538e89'
        ,'41e8bb616490ba258ade',
        ,'2ba3b02edc28079b01d7',
        ,'09c462e84a813192c626',
        ,'c8713c32b75a12e579ee',
        ,'3b1e40d2cf7c3a3400d2',
        ,'cca95f8d5929c890b801',
        '46e17af4e642a9f1c95e',
        '206800ac3a7ce2cd9fb2',
        '65a54ca6aa6c0cbd0377',
        'a4b09c262218a0d9e899',
        'f99351cf00ce71864f55',

        'a627727949470658e649',
        'b211fa46ccf93cc5ea67',
        '3ee81a0af2bcc7a49fe3',

        'f0dbcc39634a091fd69b',
        'af7d5d94f138668226ab',
        'd58d2e06d91f1fcc1734',
      ],
      hy:['f6763ef4c7cca7225efb','d09cf958a84e5de25416','6f963ee7ef2204842267','50ac080cad4cff36ffc3','df7d6ac7df84f181a688','a25ab586a3553ff8eaf1','9deac08f2e3673ad300f','feaf67bcda0c309738ef','3d0b2634f608542d1192','4eaf5ef1fd96e08adae5','a792ffc806e9f33e292f','b2e529e765d0b0e5912e','906401571e91d8291402', '524b9ab96ac72038628f','2a5ce625e65e99284120','e3d11badf345bc4f0741',
        '0d98a87a735b5c65f336','17508515f18f416f5e59','c0603a5cb631ed0be6da','b8db99e2656e2a0ec32f','4357fefbc7f2e33ad75c','2881c6532d20213bde56', '830165add00acbf602b7','f328ba502923cf699f5d','73673fbd251d2b0124d9','2b68fce0d791a7fbc6da'],
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      money:200,
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMwebPay:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],



    }
  },

  methods:{

    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },

    //总汇规则
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }
          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },
    // //导出表单api
    // exportExcel () {
    //   /* generate workbook object from table */
    //   var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
    //   var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)
    //
    //   var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    //   try {
    //     FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
    //   } catch (e) {
    //     if (typeof console !== 'undefined') {
    //       console.log(e, wbout)
    //     }
    //   }
    //   return wbout
    // },
//导出文档api
    exportExcel() {
      excel('exportTab','数据导出')
    },
    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },

    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //合并json
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },

    //点击查询
    getDataList() {


      this.loading=true
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMwebPay=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]

      if(this.userUalue[0]==="tangtang"){
        this.isDisable = true
        this.TimeChange();
      }else if(this.userUalue[0]==="zuoen"){
        this.isDisable = true
        this.TimeChangetozuoen();
      }else if(this.userUalue[0]==="xiaoqing"){
        this.isDisable = true
        this.TimeChangetoxiaoqing();
      }else if(this.userUalue[0]==="jiaqi1"){
        this.isDisable = true
        this.TimeChangeto1();
      }else if(this.userUalue[0]==="wangxin"){
        this.isDisable = true
        this.TimeChangetowangxin();
      }


    },


    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance = this.temp1[key].balance / 100000
        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }





        this.ctrJson[0].CTR = this.temp1[key].dailyBudget
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);





        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.ctrJson[0].CTR!=-1){
          t=this.ctrJson[0].CTR/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=true
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }


      this.loading=false
    },

    //查询广告效果api
    async PostListQuery(parms){
      this.$message.success("正在查询第"+parms.a+"条")

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {        if (resp.data.code!==60806){

        if (resp.data.data.items !=null){
          if (this.value==="HOUR"){
            // 存取小时的数据[]
            this.sums=this.sums+1;
            console.log(resp.data.data.items)
            this.Hourmap.set(this.sums,resp.data.data.items)

            // console.log(this.Hourmap.get(parms.a))
            let arr=[];
            let map=new Map;
            for(let key in resp.data.data.items){
              var time=new Date(resp.data.data.items[key].reportTime)
              let reTimeHour=time.getHours(); //获取返回整点时间
              var date=new Date()
              let hour=date.getHours();  // 获取当前时间
              if (hour===reTimeHour){
                arr.push(key)   //定位现在整时位置
                map.set(key,resp.data.data.items[key])// 记录下现在的数据
              }
            }
            for (let keys in arr){

              this.datadata.push(map.get(arr[keys]))
              let obj={
                ids:resp.data.data.items[arr[keys]].campaignId,
                lengths:arr.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:arr.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }else{
            console.log(resp.data.data.items)
            for (let b=0;b<resp.data.data.items.length;b++){
              this.datadata.push(resp.data.data.items[b])
              let obj={
                ids:resp.data.data.items[b].campaignId,
                lengths:resp.data.data.items.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:resp.data.data.items.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }

        }}
      })

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/finance/update/dailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.dialog1=false;
          this.getDataList()
        }

      })


    },

    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },

    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },

    async TimeChange () {
      if (this.userUalue[1]==="fjwc"){
        for (let a = 0; a < this.fjwc.length; a++) {
          if(a===this.fjwc.length-1){
            console.log(this.sks)
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.tangtang[0],
              adid:this.fjwc
            }
            await this.PostListQuery(parms)
          }else {
            this.sks=this.tangtang[1]
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.sks,
              adid:this.fjwc
            }
            await this.PostListQuery(parms)
          }
        }
        //渲染页面
        this.windowList()

      } else if(this.userUalue[1]=="hy"){
        this.sks=this.tangtang[2]
        this.sums=0;
        for (let a = 0; a < this.hy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.hy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }


      else if(this.userUalue[1]="zjwc"){
        this.sks=this.tangtang[0]
        this.sums=0;
        for (let a = 0; a < this.zjwc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.zjwc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }

    },

    async TimeChangeto1 () {
      if (this.userUalue[1]==="hzbxm1"){
        this.sks=this.jiaqi1[0]
        this.sums=0;
        for (let a = 0; a < this.hzbxm1.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hzbxm1
          }
          await this.PostListQuery(parms)
        }
        // this.sks=this.jiaqi1[1]
        // for (let a = 0; a < this.hzbxm2.length; a++) {
        //   let parms={
        //     a:a,
        //     startDate:this.value2.at(0),
        //     endDate: this.value2.at(1),
        //     summaryType: this.value,
        //     level: this.values,
        //     token:this.sks,
        //     adid:this.hzbxm2
        //   }
        //   await this.PostListQuery(parms)
        // }
        //渲染页面
        this.windowList()
      }
    },


    async TimeChangetowangxin () {
      if (this.userUalue[1]==="cesuan"){
        this.sks=this.wangxin[0]
        this.sums=0;
        for (let a = 0; a < this.cesuan.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.cesuan
          }
          await this.PostListQuery(parms)
        }

        this.windowList()
      }
    },
    async TimeChangetoxiaoqing () {
      if (this.userUalue[1]==="ysgx"){

        for (let a = 0; a < this.xiaoqing.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.xiaoqing[a] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.ysgx[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.xiaoqing[a] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.ysgx[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面

        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp1[key].dailyBudget
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);


            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }

          this.datas = this.temp2
          this.isDisable = false
        }, 1000)



      }
      if (this.userUalue[1]==="zjwc1"){
        this.sks=this.xiaoqing1[0]
        this.sums=0;
        for (let a = 0; a < this.zjwc1.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zjwc1
          }
          await this.PostListQuery(parms)
        }
        // for (let a = 0; a < this.fjwc.length; a++) {
        //   if(a===this.fjwc.length-1){
        //
        //     console.log(this.sks)
        //     let parms={
        //       a:a,
        //       startDate:this.value2.at(0),
        //       endDate: this.value2.at(1),
        //       summaryType: this.value,
        //       level: this.values,
        //       token:this.tangtang[0],
        //       adid:this.fjwc
        //     }
        //     await this.PostListQuery(parms)
        //   }else {
        //     this.sks=this.tangtang[1]
        //     let parms={
        //       a:a,
        //       startDate:this.value2.at(0),
        //       endDate: this.value2.at(1),
        //       summaryType: this.value,
        //       level: this.values,
        //       token:this.sks,
        //       adid:this.fjwc
        //     }
        //     await this.PostListQuery(parms)
        //   }
        // }
        //渲染页面
        this.windowList()


      }


    },

  },
  created () {

  },
}
</script>



// WEBPACK FOOTER //
// src/components/jiaqi.vue